import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { shooterSeasonDetail, formatDisciplineLabel, formatRankingDate } from '../../lib/conventionRankings';

@observer
class ConventionRankingShooterDetail extends Component {
    render() {
        const { participant, disciplineKey = '' } = this.props;
        const { conventionResultStore } = this.props.stores;
        const { rankings } = conventionResultStore;
        const detail = shooterSeasonDetail(rankings.rows || [], disciplineKey, participant);

        if (!detail) {
            return (
                <div class='p-3'>
                    <Text id='convention.no-results-yet-short'>No results.</Text>
                </div>
            );
        }

        const [stageType, weaponClass] = disciplineKey.split('::');

        return (
            <div class='p-3'>
                <div class='mb-3'>
                    <h4 class='mb-0' style='padding-right: 60px;'>{detail.name}</h4>
                    {detail.club && <div class='text-body-secondary'>{detail.club}</div>}
                    <div class='small mt-1'>
                        {formatDisciplineLabel(stageType, weaponClass)}
                        {rankings.year > 0 && <> · {rankings.year}</>}
                    </div>
                </div>

                <div class='small text-body-secondary mb-2'>
                    <Text id='convention.rankings-counted-help'>The 3 best results count in the total.</Text>
                </div>

                <div class='table-responsive'>
                    <table class='table table-sm align-middle'>
                        <thead>
                            <tr>
                                <th><Text id='convention.rankings-date'>Date</Text></th>
                                <th><Text id='convention.rankings-convention-number'>Stevnenr</Text></th>
                                <th><Text id='convention.rankings-lag'>Lag</Text></th>
                                <th class='text-end'><Text id='convention.rankings-poeng'>Points</Text></th>
                                <th class='text-end'><Text id='convention.rankings-inner'>Inner hits</Text></th>
                                <th class='text-end'>%</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {detail.results.map(row => (
                                <tr key={`${row.convention}-${row.stageMd5}`} class={row.counted ? 'fw-bold' : 'text-body-secondary'}>
                                    <td>{formatRankingDate(row.date)}</td>
                                    <td>{row.nsfNumber > 0 ? row.nsfNumber : ''}</td>
                                    <td>{row.lagIdx > 0 ? row.lagIdx : ''}</td>
                                    <td class='text-end'>{row.poeng}</td>
                                    <td class='text-end'>{row.innertreff}</td>
                                    <td class='text-end'>{row.percent !== null ? `${row.percent} %` : ''}</td>
                                    <td>{row.counted && <i class='fa-solid fa-star text-warning' />}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr class='fw-bold'>
                                <td colspan='3'><Text id='convention.rankings-total'>TOTAL</Text></td>
                                <td class='text-end'>{detail.totalPoeng}</td>
                                <td class='text-end'>{detail.totalInnertreff}</td>
                                <td class='text-end'>{detail.averagePercent !== null ? `${detail.averagePercent} %` : ''}</td>
                                <td />
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class='small text-body-secondary'>
                    <Text id='convention.rankings-percent-help'>% = your result against the best result in the weapon class at that stevne. The total shows the season average.</Text>
                </div>
            </div>
        );
    }
}

export default ConventionRankingShooterDetail;
